import React, { useState } from "react";
import { api } from "../api";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogTitle,
} from "./tailwind/dialog";
import { Field, Label } from "./tailwind/fieldset";
import { Button } from "./tailwind/button";
import { Textarea } from "./tailwind/textarea";

const ShareModal = ({
  campaign,
  scenarioId,
  isModalShareOpen,
  setIsModalShareOpen,
  isAutomation,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [shareUrl, setShareUrl] = useState("");

  const handleShareConfirmation = async () => {
    setIsLoading(true);
    const url = await api.getScenarioShareableLink({
      scenarioId: scenarioId,
    });
    setShareUrl(url);
    setIsLoading(false);
  };

  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(shareUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Dialog
      key="dialog_share"
      open={isModalShareOpen}
      onClose={() => {
        setIsModalShareOpen(false);
        setShareUrl("");
      }}
    >
      <DialogTitle>Share this campaign </DialogTitle>
      <DialogBody className="flex-1 overflow-y-auto scrollbar">
        {shareUrl === "" && (
          <>
            <p>
              {`You are about to generate a link to share the ${
                isAutomation ? "automation" : "campaign"
              }`}{" "}
              <b>{campaign?.name}</b>
            </p>
            <p>This link will be available for 24 hours</p>
          </>
        )}
        {shareUrl !== "" && (
          <Field>
            <div className="mb-2">
              <Label>
                {`Send this link to share the ${
                  isAutomation ? "automation" : "campaign"
                }`}{" "}
                <b>{campaign?.name}</b>
              </Label>
            </div>
            <Textarea
              name="sharCodeLink"
              defaultValue={shareUrl}
              readOnly
              resizable={false}
            />
          </Field>
        )}
      </DialogBody>
      <DialogActions>
        {shareUrl === "" && (
          <>
            <Button
              color="secondaryButton"
              onClick={() => {
                setIsModalShareOpen(false);
                setShareUrl("");
              }}
              className="min-w-[100px] h-10"
            >
              Cancel
            </Button>
            <Button
              color="primaryButton"
              onClick={() => handleShareConfirmation()}
              className="min-w-[100px] h-10"
              loading={isLoading}
            >
              Share
            </Button>
          </>
        )}
        {shareUrl !== "" && (
          <>
            <Button
              color="secondaryButton"
              onClick={() => {
                setIsModalShareOpen(false);
                setShareUrl("");
              }}
              className="min-w-[100px] h-10"
            >
              Close
            </Button>
            <Button
              color="primaryButton"
              disabled={copied}
              onClick={handleCopy}
              className="min-w-[100px] h-10"
              loading={isLoading}
            >
              {copied ? "Copied!" : "Copy link"}
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ShareModal;
